import { ReactNode } from 'react';
import { FocusableItem, MenuGroup, MenuItem } from '@szhsin/react-menu';

import InputSearch, { InputSearchProps } from '@/design_system/InputSearch/InputSearch';
import { useLoadMore } from '@/utils/useLoadMore';

import { Loader } from '../shared';

export const FilterSearch = ({
  inputProps,
  isLoading,
  isLoadingMore,
  onLoadMore,
  children,
}: {
  inputProps: InputSearchProps;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
  children: ReactNode;
}) => {
  const loadNextPageTriggerRef = useLoadMore(onLoadMore);

  return (
    <>
      <FocusableItem>{({ ref }) => <InputSearch ref={ref} {...inputProps} />}</FocusableItem>
      <MenuGroup takeOverflow style={{ maxHeight: '424px', overflowY: 'auto' }}>
        {!isLoading && children}
        {(isLoading || isLoadingMore) && (
          <MenuItem disabled style={{ justifyContent: 'center' }}>
            {Loader}
          </MenuItem>
        )}
        <div ref={loadNextPageTriggerRef} className="filters-menu__filter-search__end" />
      </MenuGroup>
    </>
  );
};
